import React, { useReducer } from "react"
import axios from "axios"
import { useEffect} from "react"
import {  Skeleton,  Stack } from '@chakra-ui/react'
// import { Button, ButtonGroup } from '@chakra-ui/react'
// import Footer from "../components/Footer";
import ShowData from "../components/ShowData"
import { useState } from "react"
import {
    Alert,
    // AlertIcon,
    AlertTitle,
    // AlertDescription,
  } from '@chakra-ui/react'
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { Button } from "@chakra-ui/react"
// import styles from "../styles/Products.module.css"
// import { Grid, GridItem } from '@chakra-ui/react'
// import { StarIcon } from '@chakra-ui/icons'
// import Footer from "../components/Footer"

function Shoes(){
    const [page, setPage] = useState(1)
// const [state, dispatch] = useReducer(reducer, intastate);
const dispatch = useDispatch()
let {products,isError,isLoading} = useSelector((state)=> state.productsReducer )
const getData =  ()=>{
    dispatch({type:"FETCH_REQUEST"})
    axios.get(`https://wearwave-server.onrender.com/prods?_page=${page}&_limit=8&category=Shoes`).then((res)=>{
        dispatch({type: "FETCH_SUCESS", payload: res.data})
        console.log(res.data);
    }).catch((err)=>{
        dispatch({type: "FETCH_FAILURE", payload: err.massage})
        // console.log(err);
    });
}
useEffect(()=>{
    getData()

},[page])
console.log(products);

// products = products.filter((el)=>{
//     return el.gender === "Male";
// })
// console.log(newData);


if(isLoading){
    return <div style={{display:"flex"}} >
       <Stack width="20%">
        <Skeleton height='100vh' margin="10px"/>
        </Stack>
        <Stack margin="10px" width={"80%"} >
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  <Skeleton height='10vh' />
  
        </Stack>
    </div>
}
else if(isError){
    return (
        // <h1>Something went wrong</h1>
        <Alert alignContent={"center"}> 
            <AlertTitle width={"fit-content"} margin={"50px auto"}>
            Something went wrong
            </AlertTitle>
             </Alert>
    )
}
else{
    return (
        <DIV>

            <ShowData data={products} /> 
        
            <div className="pagination">

<Button disabled={page===1} onClick={()=> setPage(page-1)} >Pre</Button>
<Button disabled >{page}</Button>
<Button onClick={()=> setPage(page+1)} >Next</Button>

</div>
        </DIV>
    )
}
}

const DIV = styled.div`
  .pagination{
    display: flex;
    gap: 20px;
    width: fit-content;
    margin: 20px  auto;
  }
  /* .pagination > button {
    background-color: black;
    color: white;
    padding: 10px 20px;
    border-radius: 10px;
  } */

`
export default Shoes;
